import {
  DATA_IMPORT_OPPORTUNITY,
  DATA_IMPORT_OPPORTUNITY_SUCCESS,
  DATA_IMPORT_OPPORTUNITY_FAILURE,
  DATA_IMPORT_SCHEMA,
  DATA_IMPORT_SCHEMA_SUCCESS,
  DATA_IMPORT_SCHEMA_FAILURE,
  DATA_IMPORT,
  DATA_IMPORT_SUCCESS,
  DATA_IMPORT_FAILURE,
  DATA_IMPORT_RESET,
  DATA_IMPORT_RESHAPE,
  DATA_IMPORT_RESHAPE_SUCCESS,
  DATA_IMPORT_RESHAPE_FAILURE,
  DATA_IMPORT_RESHAPE_RESET,
} from "./actionType";

const initialState = {
  //DATA_IMPORT_OPPORTUNITY
  dataImportOpportunity: [],
  dataImportOpportunityLoading: false,
  dataImportOpportunityError: null,
  //DATA_IMPORT_SCHEMA
  importSchema: null,
  importSchemaLoading: false,
  importSchemaError: null,
  //DATA_IMPORT
  importResult: null,
  importLoading: false,
  importError: null,
  //DATA_IMPORT_RESHAPE
  reshapeResult: null,
  reshapeLoading: false,
  reshapeError: null,
};

const dataImportReducer = (state = initialState, action) => {
  switch (action.type) {
    case DATA_IMPORT_OPPORTUNITY:
      return {
        ...state,
        dataImportOpportunityLoading: true,
        dataImportOpportunityError: null,
      };
    case DATA_IMPORT_OPPORTUNITY_SUCCESS:
      return {
        ...state,
        dataImportOpportunity: action.payload,
        dataImportOpportunityLoading: false,
        dataImportOpportunityError: null,
      };
    case DATA_IMPORT_OPPORTUNITY_FAILURE:
      return {
        ...state,
        dataImportOpportunityLoading: false,
        dataImportOpportunityError: action.payload,
      };

    //DATA_IMPORT_SCHEMA
    case DATA_IMPORT_SCHEMA:
      return { ...state, importSchemaLoading: true, importSchemaError: null };
    case DATA_IMPORT_SCHEMA_SUCCESS:
      return {
        ...state,
        importSchemaLoading: false,
        importSchema: action.payload,
      };
    case DATA_IMPORT_SCHEMA_FAILURE:
      return {
        ...state,
        importSchemaLoading: false,
        importSchemaError: action.payload,
      };

    //DATA_IMPORT
    case DATA_IMPORT:
      return {
        ...state,
        importLoading: true,
        importError: null,
        importResult: null,
      };
    case DATA_IMPORT_SUCCESS:
      return {
        ...state,
        importLoading: false,
        importResult: action.payload,
      };
    case DATA_IMPORT_FAILURE:
      return {
        ...state,
        importLoading: false,
        importError: action.payload,
      };
    case DATA_IMPORT_RESET:
      return { ...state, importResult: null, importError: null };

    //DATA_IMPORT_RESHAPE
    case DATA_IMPORT_RESHAPE:
      return {
        ...state,
        reshapeLoading: true,
        reshapeError: null,
        reshapeResult: null,
      };
    case DATA_IMPORT_RESHAPE_SUCCESS:
      return {
        ...state,
        reshapeLoading: false,
        reshapeResult: action.payload,
      };
    case DATA_IMPORT_RESHAPE_FAILURE:
      return {
        ...state,
        reshapeLoading: false,
        reshapeError: action.payload,
      };
    case DATA_IMPORT_RESHAPE_RESET:
      return {
        ...state,
        reshapeResult: null,
        reshapeError: null,
        reshapeLoading: false,
      };

    default:
      return state;
  }
};

export default dataImportReducer;
